import React from "react";

export default function Logo({ variant = "dark", size = 38 }) {
  const frame = variant === "light" ? "#7E9AC0" : "#4E6E96";
  const bars = variant === "light" ? "#FFFFFF" : "#0B2545";
  const accent = "#C2643B";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      className="logo-mark"
    >
      <path d="M32 5 55 18.5v27L32 59 9 45.5v-27L32 5z" fill="none" stroke={frame} strokeWidth="2.4" />
      <path d="M32 5 55 18.5 32 32 9 18.5 32 5z" fill={frame} opacity="0.14" />
      <rect x="18" y="38" width="7" height="11" fill={bars} />
      <rect x="28.5" y="29" width="7" height="20" fill={bars} />
      <rect x="39" y="18" width="7" height="31" fill={accent} />
    </svg>
  );
}
